// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"sidenav_sideNav__2KSyZ","navItemText":"sidenav_navItemText__1qP67","open":"sidenav_open__1R8z_"};